import { FormUnit, type GetFormInput } from "@suse-o11y/signal/form";
import { z } from "zod";

import { ALL_CALCULATIONS, type Calculation } from "~/tools/calculate-value-from-points";

type FormState = FormUnit<string, ReadonlyArray<string>, Calculation>;

type Input = GetFormInput<FormState>;

function init(initial: Input): FormState {
	return FormUnit(initial, {
		schema: z.enum(ALL_CALCULATIONS),
	});
}

const FormState = {
	init,
} as const;

export { FormState };
